import axios from 'axios';
import { URL } from '../utils/constant';

const { store } = require('../store');

// Create Axios instance
export const api = axios.create({
  baseURL: URL.base,
});

// Listener to update token dynamically
function listener() {
  const token = store.getState().user.token;
  api.defaults.headers.common['Authorization'] = token;
}
store.subscribe(listener);

// Add response interceptor
api.interceptors.response.use(
  (response) => response, // Pass through if successful
  async (error) => {
    if (error.response && error.response.status === 401) {
      console.log('Token Expired');
      try {
        // Perform logout
        sessionStorage.removeItem('auth');
        window.location.href = '/';
      } catch (logoutError) {
        console.error('Error during logout:', logoutError);
      }
    }
    return Promise.reject(error); // Propagate error
  }
);
